import React from 'react';
import { motion } from 'framer-motion';
interface FadeInUpProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function FadeInUp({
  children,
  delay = 0,
  className = ''
}: FadeInUpProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut',
    delay
  }} className={className} data-id="element-13">
      {children}
    </motion.div>;
}